import { Card, Col, Row } from "react-bootstrap";
import Slider from "react-slick";
import CustomImage from "../CustomImage";
import format from "date-fns/format";
import { formatOrder } from "../../utils/constants";
import LazyReveal from "../LazyReveal";
import CardShimmer from "./CardShimmer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface IBlogsList {
  sliderSettings?: any;
  styles?: any;
  detailData?: any;
  pathCondition?: boolean;
  latestNews?: Array<any>;
  isLoading?: boolean;
  onVisible?: () => void;
}

const NewsList: React.FC<IBlogsList> = ({
  sliderSettings,
  styles,
  detailData,
  pathCondition,
  latestNews = [],
  isLoading,
  onVisible,
}) => {
  return (
    <LazyReveal shimmer={<CardShimmer />} onVisible={onVisible} rootMargin="100px">
      <>
        {isLoading ? (
          <CardShimmer />
        ) : latestNews.length > 0 ? (
          <Slider
            {...sliderSettings}
            slidesToShow={latestNews.length < 3 ? latestNews.length : 3}
          >
            {latestNews.map((blog: any, index: number) => {
              return (
                <div className={styles.allnews} key={index}>
                  <Row className="text-center">
                    <a
                      href={
                        detailData.isExternalLink && detailData.externalLink
                          ? detailData.externalLink
                          : `/${pathCondition ? "news" : "blogs"}/${blog.slug}`
                      }
                    >
                      <Col lg={12} md={12} sm={12}>
                        <Card className={styles.card}>
                          <div className={styles.cardImg}>
                            <CustomImage
                              src={blog.newimageUrl?.imageUrl}
                              alt={blog.newimageUrl?.alt}
                              width={370}
                              height={220}
                              object-fit="fill"
                            />
                          </div>
                          <Card.Body className={styles.cardBody}>
                            {blog.category && (
                              <h6 className={styles.blogsCategories}>
                                {blog.category}
                              </h6>
                            )}
                            <h5>{blog.title}</h5>
                            {blog.shortDescription && (
                              <p className={styles.shortDescription}>
                                {blog.shortDescription}
                              </p>
                            )}
                            <div className={styles.bottom}>
                              <span>
                                {format(new Date(blog.date), formatOrder)}
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </a>
                  </Row>
                </div>
              );
            })}
          </Slider>
        ) : (
          "No Related News"
        )}
      </>
    </LazyReveal>
  );
};

export default NewsList;
